(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      // Honey & Paw (2026-10-18): below 990px the header folds to menu + logo + cart while
      // scrolling down and unfolds on the first scroll up (or back at the top). CSS does the
      // folding via .hp-compact; this only steers the class.
      this.hpCompactMq = window.matchMedia('(max-width: 989px)');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.hpCompactMq.matches) {
        // Folding/unfolding changes the header's height; scroll anchoring then nudges scrollTop
        // to keep the content still, which reads as a scroll in the opposite direction. Ignore
        // scroll deltas for the length of that transition after each toggle.
        const now = performance.now();
        if (!this.hpLockUntil || now >= this.hpLockUntil) {
          const delta = scrollTop - this.currentScrollTop;
          let want = null;
          if (scrollTop <= Math.max(this.headerBounds.bottom || 0, 8)) want = false;
          else if (delta > 4) want = true;
          else if (delta < -6) want = false;
          if (want !== null && want !== this.header.classList.contains('hp-compact')) {
            this.header.classList.toggle('hp-compact', want);
            this.hpLockUntil = now + 420;
          }
        }
      } else if (this.header.classList.contains('hp-compact')) {
        this.header.classList.remove('hp-compact');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hero-b"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var v=document.getElementById('hpHerobVid');
    if(!v||v.dataset.hpBound)return; v.dataset.hpBound='1';
    function pick(){
      var wide=window.innerWidth>860;
      var src=wide?v.dataset.desktop:v.dataset.mobile;
      var poster=wide?v.dataset.posterDesktop:v.dataset.posterMobile;
      if(poster&&v.poster!==poster)v.poster=poster;
      if(src&&!v.src.endsWith(src)){v.src=src;v.play().catch(function(){});}
    }
    pick(); window.addEventListener('resize',pick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-newsletter-b"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e){
    var b=e.target.closest('.hp-newsb__copy'); if(!b) return;
    if(navigator.clipboard){ navigator.clipboard.writeText(b.dataset.hpCopy); b.textContent='Copied'; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-quiz-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('hpQz');
    if (!root || root.dataset.hpBound) return;
    root.dataset.hpBound = '1';

    // Result sentence: "For a puppy who could sleep better."
    var SUBJ = {
      young: { dog: 'a puppy', cat: 'a kitten', all: 'a puppy and a kitten' },
      adult: { dog: 'a grown-up dog', cat: 'a grown-up cat', all: 'a dog and a cat' },
      senior: { dog: 'a senior dog', cat: 'a senior cat', all: 'a senior dog and cat' }
    };
    var CLAUSE = { beds: 'who could sleep better', toys: 'who gets bored and chews', 'bowls-feeders': 'who inhales dinner', grooming: 'who sheds on everything' };
    var CLAUSE_PL = { beds: 'who could sleep better', toys: 'who get bored and chew', 'bowls-feeders': 'who inhale dinner', grooming: 'who shed on everything' };
    var YOUNG_LABEL = { dog: 'Puppy', cat: 'Kitten', all: 'Puppy or kitten' };
    var ans = {}, picks = [], shown = 0, PAGE = 4, renderToken = 0;
    var res = document.getElementById('hpQzRes');
    var waitHTML = res.innerHTML;

    var POOLS = {};
    try { POOLS = JSON.parse(root.querySelector('[data-qz-pools]').textContent); } catch (e) {}
    var poolCache = {};
    // Fetch one pool (12 market-priced cards) through the Section Rendering API. Cached per key;
    // a failed request is forgotten so the next attempt retries.
    function fetchPool(key) {
      if (poolCache[key]) return poolCache[key];
      var url = POOLS[key];
      if (!url) return Promise.resolve([]);
      var p = fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=hp-quiz-pool', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return [].slice.call(doc.querySelectorAll('.hp-qz__card'));
        })
        .catch(function () { delete poolCache[key]; return null; });
      poolCache[key] = p;
      return p;
    }
    function prefetchSpecies(sp) {
      ['beds', 'toys', 'bowls-feeders', 'grooming'].forEach(function (n) { fetchPool(sp + '-' + n); });
    }
    function sortCards(cards) {
      cards = cards.slice();
      if (ans.age === 'young') cards.sort(function (a, b) { return +a.dataset.price - +b.dataset.price; });
      if (ans.age === 'senior') cards.sort(function (a, b) { return +b.dataset.price - +a.dataset.price; });
      return cards;
    }
    function subject() { return SUBJ[ans.age][ans.sp] + ' ' + (ans.sp === 'all' ? CLAUSE_PL : CLAUSE)[ans.need]; }
    function slotHTML(card, i) {
      // One badge per card: the first slot carries "Best match" and hides the product's own badge.
      return '<div class="hp-qz__slot' + (i === 0 ? ' is-best' : '') + '">' + (i === 0 ? '<span class="hp-qz__rank">Best match</span>' : '') + card.outerHTML + '</div>';
    }
    function ctaHTML(key) {
      var left = picks.length - shown;
      return '<a class="hp-qz__all" href="' + (POOLS[key] || '/collections/all') + '">See all that fit</a>' +
        (left > 0 ? '<button type="button" class="hp-qz__link" data-more>See ' + Math.min(PAGE, left) + ' more</button>' : '') +
        '<button type="button" class="hp-qz__link" data-clear>Clear</button>';
    }

    function syncPills() {
      root.querySelectorAll('.hp-qz__pill').forEach(function (p) {
        p.setAttribute('aria-pressed', ans[p.dataset.k] === p.dataset.v ? 'true' : 'false');
      });
      // The young pill follows the species: Puppy for dogs, Kitten for cats.
      var young = root.querySelector('.hp-qz__pill[data-v="young"]');
      if (young && young.lastChild && young.lastChild.nodeType === 3) young.lastChild.textContent = YOUNG_LABEL[ans.sp] || 'Puppy or kitten';
    }
    function render() {
      syncPills();
      var left = ['sp', 'age', 'need'].filter(function (k) { return !ans[k]; }).length;
      if (left) {
        res.innerHTML = waitHTML;
        res.querySelector('.hp-qz__count').textContent = left + (left === 1 ? ' tap' : ' taps') + ' to go';
        return;
      }
      var key = ans.sp + '-' + ans.need;
      var token = ++renderToken;
      var lead = '<p class="hp-qz__count">Four picks, instantly</p><p class="hp-qz__lead"><b>For ' + subject() + '.</b> Change any pill and the picks change with it.</p>';
      // Usually instant: the pools were prefetched when the pet pill was tapped.
      res.innerHTML = lead + '<p class="hp-qz__err">Finding the best matches&hellip;</p>';
      fetchPool(key).then(function (cards) {
        if (token !== renderToken) return; // answers changed while loading
        if (cards === null) {
          res.innerHTML = lead + '<p class="hp-qz__err">We could not load the picks just now. <a href="' + (POOLS[key] || '/collections/all') + '">Browse the whole category instead</a>, or try again in a moment.</p>';
          return;
        }
        picks = sortCards(cards);
        shown = Math.min(PAGE, picks.length);
        res.innerHTML = lead +
          '<div class="hp-qz__results">' + picks.slice(0, shown).map(slotHTML).join('') + '</div>' +
          '<div class="hp-qz__cta" id="hpQzCta">' + ctaHTML(key) + '</div>';
      });
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('.hp-qz__pill');
      if (pill) {
        ans[pill.dataset.k] = pill.dataset.v;
        if (pill.dataset.k === 'sp') prefetchSpecies(pill.dataset.v);
        render();
        return;
      }
      if (e.target.closest('[data-clear]')) { ans = {}; render(); return; }
      if (e.target.closest('[data-more]')) {
        var next = picks.slice(shown, shown + PAGE);
        res.querySelector('.hp-qz__results').insertAdjacentHTML('beforeend', next.map(function (c, i) { return slotHTML(c, shown + i); }).join(''));
        shown += next.length;
        document.getElementById('hpQzCta').innerHTML = ctaHTML(ans.sp + '-' + ans.need);
      }
    });
    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
